<nav>
  <header class="nav-header">
    <sort-search-filter-header [title]="title" [enableSort]="true" [enableFilter]="true" [enableSearch]="true" [sortOptions]="sortOptions"
    (onSort)="onSortChanged($event)" (onSearch)="onSearchFilter($event)" (onFilter)="onSearchFilter($event)"></sort-search-filter-header>
  </header>
  @if (!loadingActive) {
    <div class="list">
      @for (navItem of navItems; track navItem) {
        <help-navigation-item class="nav-item" (keydown.enter)="navigate(navItem.id, navItem.categoryId)"
          [item]="navItem" [routerLink]="['/help-library', navItem.categoryId, navItem.id]" routerLinkActive="active-link"
          [routerLinkActiveOptions]="{ exact: false}">
        </help-navigation-item>
      }
      @if (!fullList || fullList.length === 0) {
        <div class="full-width text-align-center bold italic">
          No help topics available.
        </div>
      }
      @if ((!navItems || navItems.length === 0) && (fullList && fullList.length > 0)) {
        <div class="full-width text-align-center bold italic">
          No help topics match the current search / filter.
        </div>
      }
    </div>
  } @else {
    <div class="loader-container">
      <static-loader></static-loader>
    </div>
  }
</nav>
